import { rebuildAspectRatio } from "./rebuildAspectRatio";
import { rebuildUrl } from "./rebuildUrl";

export const functions = [rebuildUrl, rebuildAspectRatio];

const automaticEnable: { [key: string]: boolean } = {};

Object.keys(functions).forEach((key) => {
  automaticEnable[key] = true;
});

export const defaultEnable = {
  ...automaticEnable,
};
